.trigger {
  color: var(--color-ds-content-subtle);
  outline-offset: var(--outline-ds-offset-focus);
}

.trigger:hover {
  color: var(--color-ds-content-subtle-hover);
}

.trigger:focus-visible {
  outline-color: var(--color-ds-border-focus);
  outline-width: var(--outline-ds-width-focus);
}

.panel {
  background-color: var(--color-ds-surface-tooltip);
  color: var(--color-ds-content-inverse);
  box-shadow: var(--shadow-ds-tooltip);
}
